import React, { useEffect } from 'react'
import SimpleTooltip from './simple-tooltip'
import { cx } from '@/utils/strings'

type HighlightTermsProps = {
  id?: string
  text: string
  terms?: Array<{ key: string; value: string }>
  triggerClassName?: string
}

export default function HighlightTerms({ text, terms, triggerClassName }: HighlightTermsProps) {
  if (!terms || terms.length === 0) return <>{text}</>
  const [processedText, setProcessedText] = React.useState<React.ReactNode>(text)

  useEffect(() => {
    setTimeout(() => {
      const result: React.ReactNode[] = []
      let remainingText = text
      let currentIndex = 0

      terms.forEach(({ key, value }) => {
        const regex = new RegExp(key, 'gi')
        let match

        while ((match = regex.exec(remainingText)) !== null) {
          const [matchedTerm] = match
          const { index } = match

          // Add text before the match
          if (index > 0) {
            result.push(remainingText.substring(0, index))
          }

          // Add the wrapped match
          result.push(
            <SimpleTooltip
              key={`${currentIndex}-${index}`}
              content={value}
              backgroundColor="Black"
              triggerClassName={cx('underline decoration-dotted cursor-help', triggerClassName)}
              isTooltipVisibleOnHover={false}
              maxWidth="480px"
            >
              {matchedTerm}
            </SimpleTooltip>
          )

          currentIndex++

          // Update remaining text to everything after this match
          remainingText = remainingText.substring(index + matchedTerm.length)

          // Reset regex lastIndex since we're updating remainingText
          regex.lastIndex = 0
        }
      })

      // Add any remaining text after all matches
      if (remainingText) {
        result.push(remainingText)
      }

      setProcessedText(result)
    }, 0)
  }, [text, terms, triggerClassName])

  return <>{processedText}</>
}
